export const validateField = (name, value, t) => {
  let error = "";
  if (name === "quantity" && value && isNaN(value)) {
    error = t("mustBeANumber");
  }
  return error;
};

export const handleFieldChange = (event, isNew, index, newIngredient, setNewIngredient, ingredients, onIngredientsChange, setErrors, t) => {
  const { name, value } = event.target;
  let updatedValue = value;

  if (name === "quantity") {
    updatedValue = value.replace(",", ".");
    if (isNaN(updatedValue)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: {
          ...prevErrors[index],
          quantity: t("validationErrors.positiveNumber"),
        },
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [index]: { ...prevErrors[index], quantity: "" },
      }));
    }
  }

  if (isNew) {
    setNewIngredient((prevIngredient) => ({
      ...prevIngredient,
      [name]: updatedValue,
    }));
  } else {
    const updatedIngredients = ingredients.map((ingredient, i) => (i === index ? { ...ingredient, [name]: updatedValue } : ingredient));
    onIngredientsChange(updatedIngredients);
  }
};

export const handleAddIngredient = (newIngredient, ingredients, onIngredientsChange, setNewIngredient, setErrors, t) => {
  const quantityError = validateField("quantity", newIngredient.quantity, t);
  const unitError = validateField("unit", newIngredient.unit, t);

  if (!quantityError && !unitError && newIngredient.name.trim()) {
    onIngredientsChange([...ingredients, newIngredient]);
    setNewIngredient({ name: "", quantity: "", unit: "", notes: "" });
    setErrors({});
  } else {
    setErrors((prevErrors) => ({
      ...prevErrors,
      new: { quantity: quantityError, unit: unitError },
    }));
  }
};

export const handleRemoveIngredient = (index, ingredients, onIngredientsChange) => {
  onIngredientsChange(ingredients.filter((_, i) => i !== index));
};

/**
 * Groups ingredients by their `group` field, normalizing missing or empty values.
 * @param {Array} ingredients - List of ingredient objects
 * @returns {Object} - Grouped ingredients as { [groupName]: Ingredient[] }
 */
export const groupIngredientsByGroup = (ingredients) => {
  if (!Array.isArray(ingredients)) return {};

  return ingredients.reduce((acc, ingredient) => {
    const groupName = ingredient.group?.trim() || "__no_group__";
    acc[groupName] = acc[groupName] || [];
    acc[groupName].push(ingredient);
    return acc;
  }, {});
};
